import React from 'react';
import Modal from '@hig/modal';
import CreateForgeApp from './CreateForgeApp';

const appCreateForgeAppModalStyles = (styles) => ({
    ...styles, 
    modal: {
        ...styles.modal,
        body: {
            ...styles.modal.body,
            overflow: "hidden",
            "@media screen and (max-width:690px)": {
                overflow: "scroll",
            },
        },
        bodyContent: {},
        window: {
            ...styles.modal.window,
            height: "630px",
            width: "690px",
            padding: "20px",
            "@media screen and (max-width:690px)": {
                width: "343px",
                height: "75vh"
            },
        },
        header: {
            ...styles.modal.header,
            alignContent: "center",
            borderBottom: "none", 
        },
        headerContent: {
            ...styles.modal.headerContent,
            margin: "0",
            paddingLeft: "35%",
            "@media screen and (max-width: 690px)": {
                paddingLeft: "65px",
            },
            "& p": {
                width: "100%",
                marginTop: "20px",
                alignSelf: "center",
                fontSize: "22px !important",
                fontWeight: "400 !important",
                lineHeight: "28px !important",
                fontFamily: "Artifakt Element, Open Sans, Helvetica, Arial, sans-serif",
                color: "#3C3C3C",
                "@media screen and (max-width: 690px)": {
                    padding: "10px auto"
                }
            }
        }
    }
});
export default function CreateForgeAppBtn() {
    const [openModal, setOpenModal] = React.useState(false);

    function onCreateAppBtnClick() {
        setOpenModal(true);
    }
    function onModalClose() {
        setOpenModal(false);
    }
    return (
        <div>
            <button
                className="x-btn-pri btn-icon bi--right fui-icon fui-icon-right create-app-btn trackit"
                // style={createForgeAppBtn}
                onClick={onCreateAppBtnClick}
            >Create Forge App</button>
            <Modal
                stylesheet={appCreateForgeAppModalStyles}
                open={openModal}
                onCloseClick={onModalClose}
                onOverlayClick={onModalClose}
                title="Create Application"
                type="alternate"
            >
                <CreateForgeApp close={onModalClose} clear={openModal}/>
            </Modal>
        </div>
    );
}